export class Informe {
  constructor(
    public id?: number,
    public titulo?: string,
    public fechaAlta?: string,
    public tabla?: string,
    public campos?: string,
    public condiciones?: string

  ) { }
}